import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'

const HomeIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
)
const AuditIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
)
const ProgramsIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
  </svg>
)
const TicketIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
  </svg>
)
const SiteIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
)
const DispatchIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
)
const DashboardIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
)
const ReportIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
)
const FleetIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" strokeLinecap="round" strokeLinejoin="round" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" />
  </svg>
)
const AdminIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
)
const UserIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
)
const MenuIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
)
const ChevronLeftIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
)
const ChevronRightIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
)

const ROLE_BADGE = {
  admin:         { label: 'Admin',      cls: 'badge-info'  },
  executive:     { label: 'Executive',  cls: 'badge-warn'  },
  regional_ops:  { label: 'Regional',   cls: 'badge-info'  },
  site_manager:  { label: 'Site',       cls: 'badge-info'  },
  field_tech:    { label: 'Tech',       cls: 'badge-info'  },
  remote_tech:   { label: 'Remote',     cls: 'badge-info'  },
}

export default function AppShell({ children }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { profile } = useAuth()
  const role = profile?.role
  const isAdmin     = role === 'admin'
  const isExec      = role === 'executive'
  const isRegional  = role === 'regional_ops'
  const isSiteMgr   = role === 'site_manager'
  const isOpsTeam   = isAdmin || isExec || isRegional

  // Unread @mentions on tickets. Re-fetched when the current route changes —
  // so navigating around the app keeps the badge fresh without us needing
  // realtime subscriptions for a v1. If someone's heavily multi-tasking
  // they'll see stale counts; acceptable trade-off.
  const [unreadMentions, setUnreadMentions] = useState(0)
  useEffect(() => {
    let cancelled = false
    async function load() {
      if (!profile?.id) { setUnreadMentions(0); return }
      const { count } = await supabase
        .from('ticket_mentions')
        .select('id', { count: 'exact', head: true })
        .eq('mentioned_id', profile.id)
        .is('read_at', null)
      if (!cancelled) setUnreadMentions(count || 0)
    }
    load()
    return () => { cancelled = true }
  }, [profile?.id, location.pathname])

  // Sidebar collapsed-vs-expanded preference. Persisted across sessions
  // because flipping it constantly is annoying. Defaults to expanded so
  // first-time users see labels and can discover the layout, then they
  // can collapse if they want more screen real estate.
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('sidebar:collapsed') === '1' }
    catch { return false }
  })
  function toggleCollapsed() {
    const next = !collapsed
    setCollapsed(next)
    try { localStorage.setItem('sidebar:collapsed', next ? '1' : '0') } catch {}
  }

  // Mobile drawer open state. Ephemeral — never persisted; closes on
  // navigation. Backdrop click and Escape also close it.
  const [mobileOpen, setMobileOpen] = useState(false)
  // Auto-close the drawer whenever the route changes so it doesn't stay
  // hanging open after the user picks a destination.
  useEffect(() => { setMobileOpen(false) }, [location.pathname])
  // Esc key closes drawer; cheap accessibility win.
  useEffect(() => {
    if (!mobileOpen) return
    function onKey(e) { if (e.key === 'Escape') setMobileOpen(false) }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [mobileOpen])

  // Tab visibility by role
  const tabs = [
    { path: '/',          label: 'Home',     Icon: HomeIcon,     show: true },
    { path: '/audits',    label: 'Audits',   Icon: AuditIcon,    show: !isExec && !isSiteMgr },
    { path: '/programs',  label: 'Programs', Icon: ProgramsIcon, show: isOpsTeam },
    { path: '/tickets',   label: 'Tickets',  Icon: TicketIcon,   show: isOpsTeam },
    // Sites visible to the ops team and to site managers (they wanted a
    // dedicated scoped view; true per-manager gating is a future follow-up).
    { path: '/sites',     label: 'Sites',    Icon: SiteIcon,     show: isOpsTeam || isSiteMgr },
    { path: '/dispatch',  label: 'Dispatch', Icon: DispatchIcon, show: isAdmin || isRegional },
    { path: '/fleet',     label: 'Fleet',    Icon: FleetIcon,    show: isAdmin || isExec || isRegional },
    { path: '/dashboard', label: 'Dashboard',Icon: DashboardIcon,show: isAdmin },
    { path: '/reports',   label: 'Reports',  Icon: ReportIcon,   show: isAdmin || isExec },
    { path: '/admin',     label: 'Admin',    Icon: AdminIcon,    show: isAdmin },
    { path: '/account',   label: 'Account',  Icon: UserIcon,     show: true },
  ].filter(t => t.show)

  const badge = ROLE_BADGE[role]

  return (
    <div className="app-shell">
      {/* Mobile topnav — only visible below 768px (CSS-controlled). It carries
          the hamburger toggle and the brand. Identity moves into the sidebar
          footer where it lives at all viewport sizes. */}
      <nav className="topnav">
        <button
          className="sidebar-toggle"
          aria-label="Open navigation"
          onClick={() => setMobileOpen(true)}>
          <MenuIcon />
        </button>
        <div className="topnav-brand">
          <img src="/logo-icon.png" alt="" style={{ width: 28, height: 28, borderRadius: 6 }} />
          CarWash Audit
        </div>
        {/* Spacer so the brand stays centered visually with the hamburger on
            the left and nothing on the right. */}
        <span style={{ width: 40 }} />
      </nav>

      {/* Backdrop only renders on mobile (display:none above 767px) and
          becomes opaque + clickable when the drawer is open. */}
      <div
        className={`sidebar-backdrop ${mobileOpen ? 'visible' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <img src="/logo-icon.png" alt="" style={{ width: 28, height: 28, borderRadius: 6, flexShrink: 0 }} />
            <span className="sidebar-brand-text">CarWash Audit</span>
          </div>
          <button
            className="sidebar-collapse-btn"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand' : 'Collapse'}
            onClick={toggleCollapsed}>
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </button>
        </div>

        <div className="sidebar-items">
          {tabs.map(({ path, label, Icon }) => {
            const active = isActive(location.pathname, path)
            const showBadge = path === '/tickets' && unreadMentions > 0
            return (
              <button
                key={path}
                className={`sidebar-item ${active ? 'active' : ''}`}
                onClick={() => navigate(path)}
                title={collapsed ? label : undefined}>
                <Icon />
                <span className="sidebar-item-label">{label}</span>
                {showBadge && (
                  <span className="sidebar-item-badge"
                    aria-label={`${unreadMentions} unread mentions`}>
                    {unreadMentions > 99 ? '99+' : unreadMentions}
                  </span>
                )}
              </button>
            )
          })}
        </div>

        {profile && (
          <div className="sidebar-footer">
            <UserIcon />
            <div className="sidebar-footer-text">
              {profile.full_name || profile.id.slice(0, 8)}
              {badge && (
                <div style={{ marginTop: 2 }}>
                  <span className={`badge ${badge.cls}`}>{badge.label}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </aside>

      <main className="main-content">{children}</main>
    </div>
  )
}

function isActive(pathname, tabPath) {
  if (tabPath === '/') return pathname === '/'
  return pathname === tabPath || pathname.startsWith(tabPath + '/')
}
